
import Vue from "vue";
import VueRouter from "vue-router";
import Expressorder from "@/views/orderevent/Expressorder";
import Myorder from "@/views/orderevent/Myorder";
import Orderdetails from "@/views/orderevent/Orderdetails";
import Orderby2 from "@/views/orderevent/Orderby2";

Vue.use(VueRouter);

export default [
  {
    path: "expressorder",//快递下单
    name: "Expressorder",
    component: Expressorder
  },
  {
    path: "orderby2",//海运下单
    name: "Orderby2",
    component: Orderby2
  },
  {
    path: "myorder",//我的订单
    name: "Myorder",
    component: Myorder
  },
  {
    path: "orderdetails/:orderNo",//订单详情
    name: "Orderdetails",
    component: Orderdetails
  }]